import { Expose } from 'class-transformer';

export default class EstimateCostError {
  start_time: string[] = []
  end_time: string[] = []
  lunch_break: string[] = []
  headcount: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}